
// system routes
import adminRoutes from '../routes/admin'
import retailRoutes from '../routes/retail';
import workstationRoutes from '../routes/workstation';
import customerRoutes from '../routes/customer'
import memberRoutes from '../routes/member'
import driverRoutes from '../routes/driver'

import { customRoutes } from '../customization'

export const getRouteConfigs = () => {

  const getRoutes = (customRoutes) => {
    return customRoutes ? customRoutes() : []
  }

  let routes = [

    ...getRoutes(customRoutes?.admin),
    ...getRoutes(customRoutes?.retail),
    ...getRoutes(customRoutes?.workstation),
    ...getRoutes(customRoutes?.customer),
    ...getRoutes(customRoutes?.member),
    ...getRoutes(customRoutes?.driver),

    ...adminRoutes(),
    ...retailRoutes(),
    ...workstationRoutes(),
    ...customerRoutes(),
    ...memberRoutes(),
    ...driverRoutes()

  ]

  return routes
}